// extracted by mini-css-extract-plugin
export default {"Brands":"Brands_Brands__DWDcJ","title":"Brands_title__xwxzN","wrapper":"Brands_wrapper__9kIns","item":"Brands_item__GSPrF"};